<div class="icon-container">
  <div *ngFor="let icon of icons; let i = index" class="icon-item">
    <img
      [src]="icon.icon"
      [alt]="'icon-' + i"
      [class.selected]="selected.includes(i)"
    />
    <input
      type="checkbox"
      [checked]="selected.includes(i)"
      (click)="toggleSelection($event, i, icon)"
    />
  </div>
</div>
